export default "__VITE_ASSET__40f62594__"